var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { tdStyles } from './shared';
var StyledTd = styled.td(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  background-color: 'inherit';\n  text-align: ", ";\n  font-weight: bold;\n  text-transform: none;\n  white-space: normal;\n"], ["\n  ", "\n\n  background-color: 'inherit';\n  text-align: ", ";\n  font-weight: bold;\n  text-transform: none;\n  white-space: normal;\n"])), tdStyles, function (_a) {
    var alignment = _a.alignment;
    return alignment || 'center';
});
var Footer = function (_a) {
    var _b = _a.column, id = _b.id, footerAriaLabel = _b.footerAriaLabel, getFooterProps = _b.getFooterProps, render = _b.render, alignment = _b.alignment;
    return (React.createElement(StyledTd, __assign({}, (footerAriaLabel && { 'aria-label': footerAriaLabel }), { alignment: alignment }, getFooterProps()), render('Footer')));
};
export default Footer;
var templateObject_1;
//# sourceMappingURL=Footer.js.map